import axiosInstance from './axiosConfig';

export default class ProtocolDefinitionApi {
  
  static getAll() {
    return axiosInstance.get(`/protocol-definitions/1.2`);
  }
}